import React from 'react';
import { Select, SelectProps } from 'antd';
import { useQuery } from 'react-query';
import { isEmpty, noop } from 'lodash';

import { getProcedureListByEntity } from 'services/workflow';

export type ProcedureInputProps = SelectProps<any> & {
  entity: string;
  onSelected?: (value: any, option: any) => void;
};

const ProcedureInput = ({
  entity,
  onSelected = noop,
  onChange = noop,
  value,
  ...otherProps
}: ProcedureInputProps) => {
  const { data } = useQuery(
    [entity, 'getProcedureListByEntity'],
    () =>
      getProcedureListByEntity({ entity: entity! }).then(
        (res) => res.list || []
      ),
    {
      staleTime: 60 * 1000,
      enabled: !isEmpty(entity),
    }
  );
  const handleChange = (value: string, option: any) => {
    onChange(value,option);
    onSelected(value, option);
  };
  return (
    <Select value={value} {...otherProps} allowClear onChange={handleChange}>
      {data?.map(({ proccode, proclabel }: any) => (
        <Select.Option value={proccode} key={proccode}>
          {proclabel}
        </Select.Option>
      ))}
    </Select>
  );
};

export default ProcedureInput;
